import axios from "axios"

//api base url
export const apiClient = axios.create(
    {
        baseURL: 'https://hegde-api.onrender.com/'
    }
)